// import {getShops} from "getShops../../api/shopStates";

const state = ()=>({
  shopState :{
    id: 0,
    name: '',
    floor: '',
    plate: '',
    instagram: '',
    phoneNo: '',
    category: '',
    categoryStore:'',
    location:'',
  }
})

const mutations = {
  SET_SHOPS(state, data){
    Object.assign(state.shopState, data);
  }
}

// const actions = {
//   async fetchShops({ commit } ) {
//     try {
//       const response = await getShops();
//
//       commit('SET_SHOPS', response);
//     }
//     catch (error) {
//
//     }
//   },
// }

// const getters = {
//   shopsGetter(state) {
//     return state.shopState;
//   }
// }


export default {
  namespaced: true,
  state,
  // actions,
  mutations,
  // getters
}
